<template>
    <v-container>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-form
                        v-on:submit.prevent="validate()"
                        ref="form"
                >
                    <v-card-title>
                        <span class="headline">{{$t('add_new_employee')}}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <div class="flex">
                                <v-text-field
                                        autofocus
                                        v-model="celular_nuevo"
                                        prepend-icon="phone_iphone"
                                        name="celular_nuevo"
                                        :label="$t('celular')"
                                        counter="10"
                                        maxlength="10"
                                        :rules="[rules.required, rules.counter, rules.number]"
                                >
                                </v-text-field>
                            </div>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialog = false"
                        >{{$t('cerrar')}}</v-btn>
                        <v-btn
                                color="primary"
                                @click="validate()"
                        >{{$t('agregar')}}</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_bloqueo" width="500"
                  persistent
        >
            <v-card class="elevation-0">
                <v-toolbar dark color="warning">
                    <v-toolbar-title>
                        {{$t('aviso')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-layout align-center justify-center>
                        <h2>{{$t('msg_no_permission')}}</h2>
                    </v-layout>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            large
                            to="/home"
                    >
                        <v-icon left>home</v-icon>
                        {{$t('inicio')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-layout v-if="info !== ''" align-center justify-center fill-height>
            <v-form @submit.prevent="create_invt_empresarial()">
                <v-card class="elevation-5" max-width="460">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            Datos de la Invitación
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-img
                                class="centrado ml-4 mr-4"
                                :src="require('../assets/intLogo.png')"
                                height="250px"
                                contain
                        ></v-img>
                        <v-table
                                id="datas"
                                dense="true"
                                fixed-header="true"
                        >
                            <thead>
                            <tr>
                                <th class="text-right"></th>
                                <th class="text-center"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td  class="text-lg-center">{{$t('Parque')}}</td>
                                <td  class="text-lg-center">{{info.park_name}}</td>
                            </tr>
                            <tr>
                                <td  class="text-lg-center">{{$t('Anfitrion')}}</td>
                                <td  class="text-lg-center">
                                    {{info.host_name}}

                                </td>
                            </tr>
                            <tr>
                                <td  class="text-lg-center">{{$t('fecha_hora')}}</td>
                                <td  class="text-lg-center">
                                    {{info.invitation.dateInv}}
                                    {{info.invitation.timeInv}}

                                </td>
                            </tr>
                            <tr>
                                <td  class="text-lg-center">{{$t('Asunto')}}</td>
                                <td  class="text-lg-center">{{info.invitation.subject}}</td>
                            </tr>
                            <tr>
                                <td  class="text-lg-center">{{$t('mensaje_vehiculo')}}</td>
                                <td  class="text-lg-center">
                                    {{info.invitation.vehicle === true ? $t('Si') : 'No'}}
                                </td>
                            </tr>
                            <tr>
                                <td  class="text-lg-center">{{$t('Notas')}}</td>
                                <td  class="text-lg-center">
                                    {{info.invitation.notes}}
                                </td>
                            </tr>
                            <tr>
                                <th class="text-center"></th>
                                <th class="text-center"></th>
                            </tr>
                            </tbody>
                        </v-table>
                        <v-autocomplete
                                outline
                                return-object
                                v-model="email"
                                :items="items"
                                prepend-icon="email"
                                :loading="isLoading"
                                :search-input.sync="search"
                                item-text="email"
                                item-value="celular"
                                :placeholder="$t('placeholder_invitados')"
                                :label="$t('Empleados')"
                                :error-messages="errores.guests"
                                :no-data-text="$t('no_resultados')"
                                clearable
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                        :selected="data.selected"
                                        class="chip--select-multi"
                                >
                                    {{ data.item.email }} - {{ data.item.celular }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                {{ data.item.email }} - {{ data.item.celular }}
                            </template>
                        </v-autocomplete>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                :loading="loading_send"
                                type="submit"
                        >
                            {{$t('enviar')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-layout>
    </v-container>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import {mapGetters, mapState} from 'vuex'

    Vue.use(VeeValidate)

    export default {
        name: 'form_invitation_park_data',
        data () {
            return {
                rules: {
                    required: value => !!value || 'Campo Requerido',
                    counter: value => value.length >= 10 || 'El Número de Celular debe de contener 10 dígitos',
                    number: value => {
                        const pattern = /^\d+$/
                        return pattern.test(value) || 'Ingresa un Campo Númerico.'
                    },
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Dirección E-Mail no Válida.'
                    },
                },
                info: '',
                vehicle: '',
                notes: '',
                cellphone: '',
                email: null,
                errores: [],
                dialog_bloqueo: false,
                dialog: false,
                celular_nuevo: '',
                entries: [],
                isLoading: false,
                search: null,
                loading_send: false,
                today: ''

            }
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['language']),
            fields () {
                if (!this.email) return []

                return Object.keys(this.email).map(key => {
                    return {
                        key,
                        value: this.email[key] || 'n/a'
                    }
                })
            },
            items () {
                return this.entries.map(entry => {
                    const email = entry.email.length > this.descriptionLimit
                        ? entry.email.slice(0, this.descriptionLimit) + '...'
                        : entry.email

                    return Object.assign({}, entry, { email })
                })
            }
        },
        watch: {
            isUpdating (val) {
                if (val) {
                    setTimeout(() => (this.isUpdating = false), 3000)
                }
            },
            search (val) {
                // Items have already been loaded
                //if (this.items.length > 0) return

                // Items have already been requested
                //if (this.isLoading) return
                if (val.length > 2){

                    this.isLoading = true

                    // Lazily load input items
                    const config = {
                        method: 'get',
                        url: 'https://empresa-service.intrare.app/empresas/empleados/filter?search=' + val,
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        }
                    };
                    axios(config)
                        .then(response => {
                            console.log(response.data)
                            if(this.entries.length > 0){
                                for(var i =0 ; i < response.data.length; i++){
                                    this.entries.push(response.data[i])
                                }
                            }
                            else
                                this.entries = response.data
                        })
                        .catch(error => {
                            console.log(error)
                        })
                        .finally(() => (this.isLoading = false))
                }
            }
        },
        created: function(){
            this.get_info_invit_empresarial()
        },
        methods:{
            validate () {
                if (this.$refs.form.validate()) {
                    this.dialog = false
                    this.add_new_employee()
                }
            },
            add_new_employee(){
                this.entries.push(
                    {
                        "email": '',
                        "celular": this.celular_nuevo
                    }
                )
                this.email.push(
                    {
                        "email": '',
                        "celular": this.celular_nuevo
                    }
                )
            },
            get_info_invit_empresarial(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/InvitationPark/referredInvitation/token/' + this.$route.params['token'],
                    headers: {
                        'authorization': 'Token ' + store.getters.getToken,
                        'Content-Type': 'application/json'
                    }
                };
                axios(config)
                    .then(response => {
                        this.info = response.data
                        if(response.data.length === 0){
                            this.dialog_bloqueo = true
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        if (error.response.status === 404)
                            this.$router.push({ path: '/' + this.$route.params['token'] })
                        if (error.response.status === 401)
                            this.dialog_bloqueo = true
                    })
            },
            get_current_date(){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd
                }

                if(mm<10)
                {
                    mm='0'+mm
                }
                this.today = yyyy + '-' + mm + '-' + dd
            },
            create_invt_empresarial(){
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.errores = []
                        this.loading_send = true
                        this.get_current_date()
                        console.log('AUTOCOMPLETE = ', this.email)
                        var guests = null
                        if (this.email !== null && this.email !== undefined) {
                            guests = []
                            guests.push(this.email.id.toString())
                        }
                        console.log('enviado = ', guests)
                        const config = {
                            method: 'PATCH',
                            url: 'https://empresa-service.intrare.app/InvitationPark/referredInvitation/finish/' + this.$route.params['token'],
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                guests: guests
                            }
                        };
                        axios(config)
                            .then(ok => {
                                console.log('Invitación Creada Correctamente.')
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
                                this.loading_send = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                                this.loading_send = false
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                    this.loading_send = false
                });
            },
            clear () {
                this.$router.push({ path: '/' })
            }
        }
    }
</script>

<style scoped>
    .centrado{
        display:block;
        margin-left: auto;
        margin-right: auto;
    }

    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        font-size: large;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #002b48;
        color: white;
    }
</style>
